module.exports = __webpack_public_path__ + "static/media/chat02.4458d74a.gif";